import React, { ReactElement } from 'react';
import { NavigationButtons } from '../../shared/NavigationButtons';
import { Form, Formik } from 'formik';
import { CoverageCheckupState, goToNextStep, updateCoverageCheckupState } from '../../../store/step';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { InsuranceDetailsForm } from '../../shared/InsuranceDetailsForm';
import { createInsuranceDetailsSchema } from '../../schema/InsuranceDetailsSchema';
import { CardPadding } from '../../shared/CardStyles';
import { CardHeader } from '../../shared/CardStyles/CardHeader';
import { useFormInteractionTracking } from '../../../hooks/useFormInteractionTracking';

function RentersInsuranceDetailsStep(): ReactElement {
  const dispatch = useDispatch();
  const { homeownersInsuranceLastReviewed: homeownersInsuranceLastReviewed } =
    useSelector((state: RootState) => state.steps);

  const formRef = useFormInteractionTracking('last_checked_renter');

  function onSubmit(values: Partial<CoverageCheckupState>): void {
    dispatch(updateCoverageCheckupState(values));
    dispatch(goToNextStep());
  }
  return (
    <CardPadding>
      <CardHeader
        header="When was the last time you looked over your renters insurance rates or
          coverage details?"
      />
      <Formik
        initialValues={{ homeownersInsuranceLastReviewed }}
        onSubmit={onSubmit}
        validationSchema={createInsuranceDetailsSchema(
          'homeownersInsuranceLastReviewed'
        )}
      >
        <Form ref={formRef}>
          <InsuranceDetailsForm name="homeownersInsuranceLastReviewed" />
          <NavigationButtons />
        </Form>
      </Formik>
    </CardPadding>
  );
}

export { RentersInsuranceDetailsStep };
